const STEPS = [
    {
        n: "01",
        title: "Get your estimate",
        body: "Snap a photo or fill in the quick form. Our AI gives you a ballpark price range in seconds — totally free.",
    },
    {
        n: "02",
        title: "We match you locally",
        body: "We connect you with a trusted panel & paint repairer in your area — the right fit for your job and region.",
    },
    {
        n: "03",
        title: "Confirm your price",
        body: "Your local repairer reviews the details, confirms the exact price and books a time that suits you.",
    },
    {
        n: "04",
        title: "Get it sorted",
        body: "Drop the car in and drive away looking the way it should — finished to a high standard.",
    },
];

export default function Process() {
    return (
        <section
            id="process"
            data-testid="process-section"
            className="py-20 md:py-28 bg-carbon border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="max-w-2xl mb-14">
                    <p className="uppercase text-xs tracking-[0.3em] text-electric mb-3">
                        How it works
                    </p>
                    <h2 className="font-display text-4xl md:text-5xl text-white font-bold leading-[1.05] tracking-tight">
                        Four steps. <em className="not-italic text-safety">Zero stress.</em>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6">
                    {STEPS.map((s, i) => (
                        <div
                            key={s.n}
                            data-testid={`process-step-${s.n}`}
                            className="relative"
                        >
                            <div className="font-display font-bold text-7xl text-white/10 leading-none">
                                {s.n}
                            </div>
                            <h3 className="font-display text-2xl text-white mt-4 font-semibold">
                                {s.title}
                            </h3>
                            <p
                                className="text-slate-400 mt-3 text-sm leading-relaxed max-w-xs"
                                dangerouslySetInnerHTML={{ __html: s.body }}
                            />
                            {i < STEPS.length - 1 && (
                                <div className="hidden md:block absolute top-8 right-0 w-px h-12 bg-white/10" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
